<div class="sp-row__space">
  <p class="sp-margin__no">
    {{ message | translate }}
  </p>

  <mat-icon class="sp-color__accent">
    {{ icon }}
  </mat-icon>
</div>
